// extracted by mini-css-extract-plugin
export default {"modalContent":"PaymentRequiredModal_modalContent__PswD2","iconWrapper":"PaymentRequiredModal_iconWrapper__-7473","alertIcon":"PaymentRequiredModal_alertIcon__EWT6J"};